export const LUGGAGE_SIZE_OPTIONS = [
  "Not sure yet",
  "Small",
  "Medium",
  "Large",
  "Extra Large",
  "Mixed sizes",
];

export const LUGGAGE_HELPER_TEXT =
  "Optional: Add luggage size or weight to help FleetX recommend a more suitable vehicle.";

export function normalizeLuggageSize(value) {
  const text = String(value || "").trim();
  return (
    LUGGAGE_SIZE_OPTIONS.find((size) => size.toLowerCase() === text.toLowerCase()) || ""
  );
}

function getPositiveNumber(...values) {
  for (const value of values) {
    if (value === undefined || value === null || value === "") continue;
    const numeric = Number(value);
    if (Number.isFinite(numeric) && numeric > 0) return numeric;
  }
  return 0;
}

export function getLuggageDetailLines(luggage = {}) {
  const bags = getPositiveNumber(
    luggage.luggageBags,
    luggage.luggage,
    luggage.luggageCount,
    luggage.numberOfLuggage
  );
  const size = normalizeLuggageSize(luggage.luggageSize);
  const weight =
    getPositiveNumber(
      luggage.luggageWeightKg,
      luggage.estimatedLuggageWeightKg,
      luggage.luggageWeight
    ) || "";
  const lines = [];

  if (bags > 0) lines.push(bags === 1 ? "1 bag" : `${bags} bags`);
  if (size) lines.push(`Size: ${size}`);
  if (weight) lines.push(`Weight: ${weight} kg`);

  return lines.length ? lines : ["Not specified"];
}

export function formatLuggageDetails(luggage = {}) {
  return getLuggageDetailLines(luggage).join(" | ");
}
